export enum ENavigationRoute {

    ConfigList = 'config-list',
    Config = 'config',
    LimitSettings = 'limit-settings',
    TestManagement = 'test-management',
    SampleList = 'sample-list',
    User = 'user',
    Error = 'error',
    Login = 'login',
    Home = ConfigList,
}
